class FlexaConverterMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeDomElements();
    this.setupEventListeners();
  }

  initializeDomElements() {
    this.domElements = {
      media: this.querySelector("[data-media]"),
    };
  }

  setupEventListeners() {
    document.addEventListener('collection-selected', (event) => this.handleCollectionSelected(event));
  }

  handleCollectionSelected(event) {
    const { handle } = event.detail;
    fetch(
      `${window.theme.routes.root}collections/${handle}?view=converter-media`
    )
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(text, 'text/html');
        const media = html.querySelector("[data-media]");

        if (media && media.innerHTML.trim().length) {
          this.domElements.media.replaceChildren(...media.children);
        }
      });
  }
}

customElements.define('flexa-converter-media', FlexaConverterMedia);